<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn outline color="primary" @click="goBack">
            Go Back
            <v-icon right>arrow_back</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs6>
        <v-chip label outline color="green">Date : {{currentDate}}</v-chip>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister" :loading="confirmLoading">
            Confirm
            <v-icon right>check_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="barcode"
                label="Barcode"
                type="text"
                v-model="queryParams.barcode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="categoryList"
                item-text="name"
                item-value="id"
                label="Choose Category"
                v-model="queryParams.categoryId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="brandList"
                item-text="name"
                item-value="id"
                label="Choose Brand"
                v-model="queryParams.brandId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="stockTakeList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.brandName }}</td>
              <td>{{ props.item.categoryName }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.barcode }}</td>
              <td>{{ props.item.factor }}/{{ props.item.unitName }}</td>
              <td>{{ props.item.openingBalance }}</td>
              <td>{{ props.item.stockInQty }} / {{ props.item.stockOutQty }}</td>
              <td>{{ props.item.stockTransferInQty }} / {{ props.item.stockTransferOutQty }}</td>
              <td>{{ props.item.stockAdjustmentLossQty }} / {{ props.item.stockAdjustmentDamageQty }} / {{ props.item.stockAdjustmentRefoundedQty }}</td>
              <td>{{ props.item.closingBalance }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseMessage }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { stockTakeService } from "../../services/stock-take-service";
import { brandService } from "../../services/brand-service";
import { categoryService } from "../../services/category-service";
import { commonService } from "../../services/common-service";
export default {
  name: "StockTakeList",

  components: {},
  data: () => ({
    user: {},
    currentDate: commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    ),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Stock Take",
        disabled: true
      }
    ],
    headers: [
      { text: "Warehouse", value: "warehouse.name" },
      { text: "Brand", value: "product.brand.name" },
      { text: "Category", value: "product.category.name" },
      { text: "Product", value: "product.name" },
      { text: "Barcode", value: "productUnit.barcode" },
      { text: "Unit", value: "productUnit.factor" },
      { text: "Open BL", value: "openBl", sortable: false },
      { text: "Stock In / Out", value: "stockInOut", sortable: false },
      {
        text: "Transfer In / Out",
        value: "stockTransferInOut",
        sortable: false
      },
      {
        text: "Adjustment Loss / Damage / Re-founded",
        value: "adjustmentLossDamageRefounded",
        sortable: false
      },
      { text: "Close BL", value: "closeBl", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "warehouse.name",
      totalItems: 0
    },
    stockTakeList: [],
    brandList: [],
    categoryList: [],
    totalRows: 0,
    messageDialogBox: false,
    responseMessage: "",
    confirmLoading: false,
    queryParams: {
      warehouseId: "",
      barcode: "",
      brandId: "",
      categoryId: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockTakeData();
      },
      deep: true
    }
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.queryParams.warehouseId = this.user.warehouseId;

    //for deep linking
    if (this.$route.query.barcode) {
      this.queryParams.barcode = this.$route.query.barcode;
    }
    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllBrand();
    this.getAllCategory();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-take-register",
        query: this.queryParams
      });
      this.getStockTakeData();
    },
    getStockTakeData() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockTakeService
        .getStockTakeData(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.stockTakeList = res.data.stockTakeList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getAllBrand() {
      brandService
        .getAllBrand()
        .then(res => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseMessage = err.response.data.message;
          }
        });
    },
    getAllCategory() {
      categoryService
        .getAllCategory()
        .then(res => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseMessage = err.response.data.message;
          }
        });
    },
    goBack() {
      this.$router.push("/stock-takes");
    },
    onRegister() {
      this.confirmLoading = true;
      stockTakeService
        .register()
        .then(res => {
          if (res) {
            this.confirmLoading = false;
            this.goBack();
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseMessage = err.response.data.message;
            this.confirmLoading = false;
            this.messageDialogBox = true;
          }
        });
    }
  }
};
</script>